
/* eslint-disable import/no-cycle */
import {
  computed, defineComponent,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import SpacesUserTransition from '@/modules/spaces/components/SpacesUserTransition.vue';
import SpacesUser from '@/modules/spaces/components/SpacesUser.vue';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';

export default defineComponent({
  components: {
    SpacesUserTransition,
    SpacesUser,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const my = computed(() => spacesStore.myContacts);
    const usersToAdd = computed(() => spacesStore.usersToAdd);
    function handleUser(accountId: string) {
      if (spacesStore.usersToAdd.includes(accountId)) {
        spacesStore.usersToAdd.splice(spacesStore.usersToAdd.indexOf(accountId), 1);
      } else {
        // usersToAdd.value.push(accountId);
        spacesStore.usersToAdd.push(accountId);
      }
    }

    return {
      spacesStore,
      my,
      NETWORK_CONTACT_TYPES,
      usersToAdd,
      handleUser,
    };
  },
});
